import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M6 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.704.706l3.588 3.588A2.4 2.4 0 0 1 20 8v12a2 2 0 0 1-2 2z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M14 2v5a1 1 0 0 0 1 1h5" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M12 18v-6" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m9 15 3 3 3-3" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_waybills_header_additional = _resolveComponent("waybills-header-additional")!
  const _component_bs_page_header = _resolveComponent("bs-page-header")!
  const _component_waybills_filters = _resolveComponent("waybills-filters")!
  const _component_bs_table_column_manager = _resolveComponent("bs-table-column-manager")!
  const _component_bs_button = _resolveComponent("bs-button")!
  const _component_waybills_table_column_number = _resolveComponent("waybills-table-column-number")!
  const _component_waybills_table_column_type = _resolveComponent("waybills-table-column-type")!
  const _component_waybills_table_column_calculation_type = _resolveComponent("waybills-table-column-calculation-type")!
  const _component_waybills_table_column_courier_payment_rate_type = _resolveComponent("waybills-table-column-courier-payment-rate-type")!
  const _component_waybills_table_column_forwarder = _resolveComponent("waybills-table-column-forwarder")!
  const _component_waybills_table_column_courier = _resolveComponent("waybills-table-column-courier")!
  const _component_waybills_table_column_car = _resolveComponent("waybills-table-column-car")!
  const _component_waybills_table_column_car_number = _resolveComponent("waybills-table-column-car-number")!
  const _component_waybills_table_column_date = _resolveComponent("waybills-table-column-date")!
  const _component_waybills_table_column_invoices = _resolveComponent("waybills-table-column-invoices")!
  const _component_waybills_table_column_as_money = _resolveComponent("waybills-table-column-as-money")!
  const _component_waybills_table_column_money = _resolveComponent("waybills-table-column-money")!
  const _component_waybills_table_column_status = _resolveComponent("waybills-table-column-status")!
  const _component_waybills_table_column_actions = _resolveComponent("waybills-table-column-actions")!
  const _component_bs_table = _resolveComponent("bs-table")!
  const _component_bs_page_table_wrapper = _resolveComponent("bs-page-table-wrapper")!
  const _component_waybill_details_modal = _resolveComponent("waybill-details-modal")!
  const _component_waybill_request_for_payment_modal = _resolveComponent("waybill-request-for-payment-modal")!
  const _component_bs_page = _resolveComponent("bs-page")!

  return (_openBlock(), _createBlock(_component_bs_page, { class: "m-waybills-page" }, {
    default: _withCtx(() => [
      _createVNode(_component_bs_page_header, null, {
        title: _withCtx(() => [
          _createTextVNode(" Диспетчерская ")
        ]),
        description: _withCtx(() => [
          _createTextVNode(" Управление путевыми листами и транспортом ")
        ]),
        additional: _withCtx(() => [
          _createVNode(_component_waybills_header_additional, {
            loading: _ctx.statisticState.isLoading,
            total: _ctx.state.pagination.totalItems,
            crew: _ctx.statisticState.crewWaybills,
            cargo: _ctx.statisticState.cargoWaybills
          }, null, 8, ["loading", "total", "crew", "cargo"])
        ]),
        _: 1
      }),
      _createVNode(_component_waybills_filters, {
        loading: _ctx.state.isLoading,
        onSubmit: _ctx.onFiltersSubmit,
        onReset: _ctx.onFiltersReset
      }, null, 8, ["loading", "onSubmit", "onReset"]),
      _createVNode(_component_bs_page_table_wrapper, {
        pagination: "",
        loading: _ctx.state.isLoading,
        failed: _ctx.state.isFailed,
        empty: _ctx.state.list.length === 0,
        "total-pages": _ctx.state.pagination.totalPages,
        "total-items": _ctx.state.pagination.totalItems,
        page: _ctx.state.pagination.page,
        "onUpdate:page": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.pagination.page) = $event)),
        limit: _ctx.state.limit,
        "onUpdate:limit": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.limit) = $event)),
        onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadWaybills(_ctx.state.pagination.page))),
        "onChange:page": _cache[4] || (_cache[4] = (page) => _ctx.loadWaybills(page)),
        "onChange:limit": _cache[5] || (_cache[5] = () => _ctx.loadWaybills(_ctx.state.pagination.page))
      }, {
        title: _withCtx(() => [
          _createTextVNode("Путевые листы")
        ]),
        actions: _withCtx(() => [
          _createVNode(_component_bs_table_column_manager, {
            columns: _ctx.COLUMNS,
            modelValue: _ctx.state.columns,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.columns) = $event))
          }, null, 8, ["columns", "modelValue"]),
          _createVNode(_component_bs_button, {
            loading: _ctx.exportState.isLoading,
            onClick: _ctx.onExportWaybills
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createTextVNode(" Экспорт ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"])
        ]),
        footer: _withCtx(() => []),
        default: _withCtx(() => [
          _createVNode(_component_bs_table, {
            columns: _ctx.state.columns,
            rows: _ctx.state.list
          }, {
            codeOneC: _withCtx(({ row }) => [
              _createVNode(_component_waybills_table_column_number, {
                id: row.id,
                number: row.codeOneC,
                onClick: _ctx.onOpenWaybillDetails
              }, null, 8, ["id", "number", "onClick"])
            ]),
            city: _withCtx(({ row }) => [
              (row.city)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(row.city.name), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" — ")
                  ], 64))
            ]),
            waybillType: _withCtx(({ row }) => [
              _createVNode(_component_waybills_table_column_type, {
                type: row.waybillType
              }, null, 8, ["type"])
            ]),
            company: _withCtx(({ row }) => [
              (row.company)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(row.company.name), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" — ")
                  ], 64))
            ]),
            calculationType: _withCtx(({ row }) => [
              _createVNode(_component_waybills_table_column_calculation_type, {
                "calculation-type": row.calculationType
              }, null, 8, ["calculation-type"])
            ]),
            courierPaymentRateType: _withCtx(({ row }) => [
              _createVNode(_component_waybills_table_column_courier_payment_rate_type, {
                courier: row.courier
              }, null, 8, ["courier"])
            ]),
            forwarder: _withCtx(({ row }) => [
              _createVNode(_component_waybills_table_column_forwarder, {
                forwarder: row.forwarder
              }, null, 8, ["forwarder"])
            ]),
            courier: _withCtx(({ row }) => [
              _createVNode(_component_waybills_table_column_courier, {
                courier: row.courier
              }, null, 8, ["courier"])
            ]),
            car: _withCtx(({ row }) => [
              _createVNode(_component_waybills_table_column_car, {
                car: row.car
              }, null, 8, ["car"])
            ]),
            carNumber: _withCtx(({ row }) => [
              _createVNode(_component_waybills_table_column_car_number, {
                car: row.car
              }, null, 8, ["car"])
            ]),
            createdAt: _withCtx(({ row }) => [
              _createVNode(_component_waybills_table_column_date, {
                date: row.createdAt
              }, null, 8, ["date"])
            ]),
            invoices: _withCtx(({ row }) => [
              _createVNode(_component_waybills_table_column_invoices, {
                invoices: row.invoices
              }, null, 8, ["invoices"])
            ]),
            additionalServicesTotalAmount: _withCtx(({ row }) => [
              _createVNode(_component_waybills_table_column_as_money, {
                money: row.additionalServicesTotalAmount
              }, null, 8, ["money"])
            ]),
            totalAmount: _withCtx(({ row }) => [
              _createVNode(_component_waybills_table_column_money, {
                money: row.totalAmount
              }, null, 8, ["money"])
            ]),
            status: _withCtx(({ row }) => [
              _createVNode(_component_waybills_table_column_status, {
                status: row.status
              }, null, 8, ["status"])
            ]),
            actions: _withCtx(({ row }) => [
              _createVNode(_component_waybills_table_column_actions, {
                waybill: row,
                onRequestForPayment: _ctx.onOpenWaybillRequestForPayment
              }, null, 8, ["waybill", "onRequestForPayment"])
            ]),
            _: 1
          }, 8, ["columns", "rows"])
        ]),
        _: 1
      }, 8, ["loading", "failed", "empty", "total-pages", "total-items", "page", "limit"]),
      _createVNode(_component_waybill_details_modal, {
        "waybill-id": _ctx.detailsState.waybillId,
        modelValue: _ctx.detailsState.isOpened,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.detailsState.isOpened) = $event)),
        onClose: _ctx.onCloseWaybillDetails
      }, null, 8, ["waybill-id", "modelValue", "onClose"]),
      _createVNode(_component_waybill_request_for_payment_modal, {
        waybill: _ctx.requestForPaymentState.waybill,
        modelValue: _ctx.requestForPaymentState.isOpened,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.requestForPaymentState.isOpened) = $event)),
        onClose: _ctx.onCloseWaybillDetails,
        onSended: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadWaybills(_ctx.state.pagination.page)))
      }, null, 8, ["waybill", "modelValue", "onClose"])
    ]),
    _: 1
  }))
}